module.exports = __webpack_public_path__ + "static/media/mike.aff242c3.jpg";